<template>
  <section class="section" id="finbridge-section">
    <v-container>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <div class="section-contents top" ref="title">
            <h6>핀브릿지는</h6>
            <h1>
              <b>데이터에서 가치를 발견해,</b><br />
              우리에게 필요한 서비스를
            </h1>
            <p>다양한 분야의 데이터에 대한 깊은 이해를 바탕으로 <br />
            흩어져 있는 데이터를 모아 분석하고 가치를 발견하여 <br />
            고객에게 꼭 필요한 서비스를 제시합니다</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <img ref="img" src="@/assets/new/image/main/arrow_down.svg" alt="scroll" />
  </section>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { gsap } from "gsap";

const { mapGetters } = createNamespacedHelpers("ui");

export default {
  name: "Finbridge",
  computed: {
    ...mapGetters(["sectionNumber"])
  },
  watch: {
    sectionNumber() {
      const { title, img } = this.$refs;

      if (this.sectionNumber === 0) {
        gsap.to(title, .5, { delay: .4, opacity: 1, y: 0 })
        gsap.to(img, .4, { delay: .7, opacity: 1, xPercent:-50, yPercent: 0 });
      }
    }
  }
};
</script>
